import { StorageService } from './StorageService';
import locales from '../../config/locales.json';
import { DEFAULT_LOCALE } from '../../constants/misc.constants';

const KEY = 'locale';

export const LanguageService = {
    setLocale,
    getCurrentLocale,
    getDefaultLocale,
    getCountryCode,
    getLanguageName,
};

function setLocale(locale: string): string {
    const _locale = locale.toLowerCase();
    StorageService.setLocal(KEY, _locale);
    document.documentElement.lang = _locale;
    return _locale;
}

function getCurrentLocale(currentlyAllowedLanguages: string[]): string {
    return StorageService.getLocal<string>(
        KEY,
        getDefaultLocale(currentlyAllowedLanguages),
    );
}

function getLanguageName(locale: string, uiLocale?: string): string {
    const languageIntl = new Intl.DisplayNames([uiLocale ?? DEFAULT_LOCALE], {
        type: 'language',
    });
    return languageIntl.of(locale) ?? locale;
}

function getCountryCode(locale: string): string {
    if (Object.hasOwn(locales, locale)) {
        return (locales as Record<string, { countryCode: string }>)[locale]
            .countryCode;
    }

    return locale;
}

function getDefaultLocale(currentlyAllowedLanguages: string[]): string {
    const browserLocales =
        navigator.languages === undefined
            ? [navigator.language]
            : navigator.languages;
    if (!browserLocales) {
        return DEFAULT_LOCALE;
    }

    let locale: string;
    for (const l of browserLocales) {
        locale = l.trim().split(/[-_]/)[0].toLowerCase();

        if (currentlyAllowedLanguages.includes(locale)) {
            return locale;
        }
    }

    if (currentlyAllowedLanguages.length > 0) {
        return currentlyAllowedLanguages[0].toLowerCase();
    }

    return DEFAULT_LOCALE;
}
